module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gd-701c23bcb3d6af9e1d01437468de4337.svg";